export default "__VITE_ASSET__CazSX$P9__"